import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectAutocompleteComponent } from './components/select-autocomplete/select-autocomplete.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { DropdownCompletePage } from './components/dropdown-complete/dropdown-complete.page';
import { RoleSelectionComponent } from './components/role-selection/role-selection.component';
import { SwitchAccountComponent } from './components/switch-account/switch-account.component';
import { ProductDatetimePickerComponent } from '../pages/products/product-datetime-picker/product-datetime-picker.component';
import { DateTimeFieldComponent } from './components/date-time-field/date-time-field.component';

@NgModule({
  declarations: [
    SelectAutocompleteComponent, 
    DropdownCompletePage,
    RoleSelectionComponent,
    SwitchAccountComponent,
    ProductDatetimePickerComponent,
    DateTimeFieldComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule,
    ReactiveFormsModule,
    NgSelectModule
  ],
  exports: [
    SelectAutocompleteComponent, 
    DropdownCompletePage,
    RoleSelectionComponent,
    SwitchAccountComponent,
    ProductDatetimePickerComponent,
    DateTimeFieldComponent,
    NgSelectModule
  ]
})
export class SharedModule { }
